import { forwardRef, Ref } from 'react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { useWhiteLabelContext } from '../../../../WhiteLabelContext'

export const WhiteLabelIcon = forwardRef<Ref<SVGSVGElement>, FontAwesomeIconProps>((props, ref) => {
  const { whiteLabel } = useWhiteLabelContext()
  const { icon, color, ...rest } = props
  return <FontAwesomeIcon style={{ color: whiteLabel.colorHex }} color={whiteLabel.colorHex} icon={icon} {...rest} />
})